import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type FavoritesStore = {
  articles: string[];
  hydrated: boolean;

  addArticle: (id: string) => void;
  removeArticle: (id: string) => void;
  setHydrated: () => void;
};

export const useFavorites = create<FavoritesStore>()(
  persist(
    (set) => ({
      articles: [],
      hydrated: false,

      addArticle: (article) => {
        set((state) => ({
          articles: state.articles.find((item) => item === article)
            ? state.articles
            : [...state.articles, article],
        }));
      },

      removeArticle: (id) => {
        set((state) => ({
          articles: state.articles.filter((i) => i !== id),
        }));
      },

      setHydrated: () => set({ hydrated: true }),
    }),
    {
      name: 'favorites',
      storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
      partialize: (s) => ({ articles: s.articles }),
    }
  )
);

export const useInFavorites = (id: string) =>
  !!useFavorites((state) => state.articles).includes(id);
